/* global $ */
import {
  Search,
  BackToTop,
  ImageGallery,
  Intro,
  MobileMenu,
  NavReveal,
  PracticePage,
  Sasaki,
  ScrollAnimations,
  ToggleClass,
} from './modules';

const modules = [
  Search,
  BackToTop,
  ImageGallery,
  Intro,
  MobileMenu,
  NavReveal,
  PracticePage,
  ScrollAnimations,
  ToggleClass,
];

$(document).ready(() => {
  new Sasaki(modules);
});
